if (typeof QuickView === "undefined") {
  const { FoxThemeStyles, FoxThemeScripts } = window;
  class QuickView {
    constructor() {
      this.modal = null;

      addEventDelegate({
        selector: "[data-product-quickview]",
        handler: (e, target) => {
          e.preventDefault();
          this.target = target;
          target.classList.add("btn--loading");
          const productHandle = target.dataset.productQuickview;
          if (productHandle) this.fetchHtml(productHandle);
        },
      });

      window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        // [ECOMHARD] Fecha somente o Quick View que ainda está realmente aberto.
        // Evita que uma referência antiga remova o prevent-scroll do cart drawer
        // depois de uma atualização AJAX do carrinho.
        if (
          this.modal &&
          this.modal.isConnected &&
          this.modal.hasAttribute("open")
        ) {
          this.modal.hide();
        }
      });
    }

    fetchHtml(productHandle) {
      loadAssets(
        [FoxThemeStyles.product, FoxThemeStyles.volumePricing],
        "quick-view-assets"
      );
      fetchSection("product-quickview", {
        url: `${window.FoxThemeSettings.base_url}products/${productHandle}`,
      })
        .then((html) => {
          this.modal = html.querySelector("modal-dialog");
          const firstModel = html.querySelector("product-model");
          this.mediaGallery = this.modal.querySelector("media-gallery");
          document.body.appendChild(this.modal);
          loadAssets(
            [
              FoxThemeScripts.productInfo,
              FoxThemeScripts.productMedia,
              FoxThemeScripts.variantsPicker,
              FoxThemeScripts.volumePricing,
            ],
            "variants-picker",
            () => {
              this.modal && this.modal.show(this.target);
              document.dispatchEvent(
                new CustomEvent("quick-view:open", {
                  detail: { productUrl: `/products/${productHandle}` },
                })
              );
              if (this.mediaGallery) {
                const thumb = this.mediaGallery.querySelector(
                  '[id^="GalleryThumbnails"]'
                );
                if (thumb) thumb.update();
                this.mediaGallery.update();
              }
              if (Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }
              this.target.classList.remove("btn--loading");
              this.handleClose();
              this.toolTip = __reInitTooltip(this.modal);

              document.dispatchEvent(
                new CustomEvent("quick-view:loaded", {
                  detail: { productUrl: `/products/${productHandle}` },
                })
              );
            }
          );
          if (firstModel) {
            loadAssets(
              [
                FoxThemeScripts.productModel,
                "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
              ],
              "product-model-assets"
            );
          }
        })
        .catch(console.error);
    }

    handleClose() {
      if (!this.modal) return;

      // [ECOMHARD] Guarda a instância exata que está sendo fechada.
      // O ModalDialog usa um timeout de 300ms no hide(); sem isso, um modal antigo
      // pode acabar removendo um novo Quick View aberto durante esse intervalo.
      const modal = this.modal;
      const toolTip = this.toolTip || [];

      modal.addEventListener(
        "close",
        () => {
          const allTooltip = [
            ...(modal.querySelector("product-info")?.toolTip || []),
            ...toolTip,
          ];
          allTooltip.forEach((item) => item.unmount());

          const quantityInputs = modal.querySelectorAll("quantity-input");
          quantityInputs.forEach((input) => {
            input.disconnectedCallback();
          });

          modal.remove();

          if (this.modal === modal) {
            this.modal = null;
            this.mediaGallery = null;
            this.toolTip = null;
          }

          // O modal remove prevent-scroll ao fechar. Se o cart drawer continua aberto,
          // a trava precisa permanecer para manter o drawer e os widgets flutuantes
          // na hierarquia correta (inclusive #rawa-container / WhatsApp).
          const cartDrawer = document.getElementById("Drawer-Cart");
          if (cartDrawer?.hasAttribute("open")) {
            document.body.classList.add("prevent-scroll");
          }
        },
        { once: true }
      );
    }
  }
  new QuickView();
  window.QuickView = QuickView;
}
